import React from "react";
import { PreloadedQuery, graphql, usePreloadedQuery } from "react-relay";

import { WidgetNote } from "widgets";
import { WANotePreviewQuery } from "./__generated__/WANotePreviewQuery.graphql";

export const WA_NOTE_PREVIEW_QUERY = graphql`
  query WANotePreviewQuery($input: PreviewWidgetNoteInput!, $storecastId: ID!)
  @raw_response_type {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetNote(input: $input) {
        ...WidgetNote_widgetNote
      }
    }
  }
`;

export function WANotePreview(props: {
  queryRef: PreloadedQuery<WANotePreviewQuery>;
  clientTitle: string;
}) {
  const data = usePreloadedQuery<WANotePreviewQuery>(
    WA_NOTE_PREVIEW_QUERY,
    props.queryRef
  );

  return (
    <WidgetNote
      mode="IDLE"
      widget={data.dashboard.previewWidgetNote}
      storecastId=""
      interactive={false}
      clientTitle={props.clientTitle}
    />
  );
}
